import { useUserEventLogger } from '@repo/tracking-service';
import { List } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import FillRegisterCert from '@/assets/illust-icons/fill-register-cert.svg';
import { useInvalidOSDialog } from '@/components/tax-refund/common/hooks/use-invalid-os-dialog';
import { INDIVIDUAL_PATHS } from '@/lib/constants/paths';
import useDetectOs from '@/lib/hooks/use-detect-os';

const IndisNPKILookupSection = () => {
  const router = useRouter();
  const detectOS = useDetectOs();
  const { sendClickEvent } = useUserEventLogger();
  const { showInvalidOSDialog } = useInvalidOSDialog();

  const handleClick = () => {
    sendClickEvent(`indis-selectauth_selectauth_commoncert`);

    if (detectOS === 'windows') {
      router.push({
        pathname: `${INDIVIDUAL_PATHS.개인공동인증서프로그램설치판단}`,
        query: router.query
      });
    } else {
      showInvalidOSDialog();
    }
  };

  return (
    <>
      <List.Basic
        left={<FillRegisterCert width={36} height={36} />}
        title={{ text: '공동인증서로 조회하기', titleStyle: 'headline-18' }}
        subText={{ text: '홈택스에 등록된 개인 인증서로 확인해요.' }}
        listIcon
        onClick={handleClick}
        className="page-padding cursor-pointer"
      />
    </>
  );
};

export default IndisNPKILookupSection;
